import { Flex } from '@mantine/core';
import styles from './GameContent.module.css';
import { TowersGrid } from './TowersGrid';

export const GameContent = () => {
  return (
    <Flex
      className={styles.content}
      data-test-id="game-main-section"
      direction="column"
      h="100%"
      w="100%"
    >
      <TowersGrid />
    </Flex>
  );
};
